import { StringHelper } from "../../../../utilities/contracts/string-helper";

export class MemberChart {
  tenantId?: string;
  chartType?: string;
  memberId?: string;
  firstName?: string;
  lastName?: string;
  dob?: string;
  gender?: string;
  dateOfServiceFrom?: string;
  dateOfServiceTo?: string;
  sourceSystem?: string;
  providerName?: string;
  groupName?: string;
  chartId?: string;
  trackingNumber?: string;
  fileName?: string;
  totalPageCount?: string;
  parentChaseID?: number;
  dateOfService?: string;

  constructor(options: Partial<MemberChart> = {}) {
    this.tenantId = StringHelper.clean(options.tenantId);
    this.chartType = StringHelper.clean(options.chartType);
    this.memberId = StringHelper.clean(options.memberId);
    this.firstName = StringHelper.clean(options.firstName);
    this.lastName = StringHelper.clean(options.lastName);
    this.dob = StringHelper.clean(options.dob);
    this.gender = StringHelper.clean(options.gender);
    this.dateOfServiceFrom = StringHelper.clean(options.dateOfServiceFrom);
    this.dateOfServiceTo = StringHelper.clean(options.dateOfServiceTo);
    this.sourceSystem = StringHelper.clean(options.sourceSystem);
    this.providerName = StringHelper.clean(options.providerName);
    this.groupName = StringHelper.clean(options.groupName);
    this.chartId = StringHelper.clean(options.chartId);
    this.trackingNumber = StringHelper.clean(options.trackingNumber);
    this.fileName = StringHelper.clean(options.fileName);
    this.totalPageCount = StringHelper.clean(options.totalPageCount);
    this.parentChaseID = options.parentChaseID;
    this.dateOfService = StringHelper.clean(options.dateOfService);
  }
}
